/**
 * Created by daniel on 01/05/17.
 */

import React, {Component} from 'react';
import {connect} from "react-redux";
import {getContentItemChildren, getRootItem} from "../../../state/content/selectors";
import Hierarchy from "./Hierarchy";
import {setUiHoveredContentItem, setUiSelectedContentItem} from "../../../state/ui/actions";
import {getUiSelectedItem} from "../../../state/ui/selectors";

class HierarchyContainer extends Component {
  
  render() {
    if (!this.props.contentTree) {return false}
    return (
      <Hierarchy
        tree={this.props.contentTree}
        hover={this.props.setHover}
        selected={this.props.setSelected}
        selectedItem={this.props.selectedItem}
      />
    );
  }
}

function mapStateToProps(state) {
  // Build hierarchy as simple object
  let root = getRootItem(state);
  function addChildren(item) {
    item.childItems = getContentItemChildren(state, item.contentId).map(addChildren);
    return item;
  }
  return {
    selectedItem: getUiSelectedItem(state),
    contentTree: root ? addChildren(root) : null
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setHover: (contentId) => dispatch(setUiHoveredContentItem(contentId)),
    setSelected: (contentId) => dispatch(setUiSelectedContentItem(contentId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HierarchyContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/HierarchyContainer.js